import React, { useState } from "react";
import Button from "src/components/Button";
import Layout from "src/components/layout/Layout";
import FilterTabs from "src/components/layout/FilterTabs";
import OfferAvailableWorkSwitch from "src/components/offer/forms/OfferAvailableWorkSwitch";
import OfferList from "src/components/offer/lists/OfferList";
import useAuth from "src/hooks/selectors/useAuth";
import useWindowSize from "src/hooks/useWindowSize";
import { useTranslation } from "react-i18next";

export default function OffersView() {
	const { t } = useTranslation("offer-view", {
		keyPrefix: "offers-view",
	});
	const auth = useAuth();
	const [sort, setSort] = useState("newest");
	const { isPhone, isTablet } = useWindowSize();

	const sorts = {
		newest: t("sort.all"),
		populair: t("sort.populair"),
		live: t("sort.live"),
	};

	if (!auth?.status?.is_onboarded) {
		return (
			<Layout
				breadcrumb={[
					{
						to: "/offers",
						label: t("title"),
						isHome: true,
					},
				]}
				title={t("title")}
			>
				<Layout.Header title={t("title")}></Layout.Header>
				<div className="flex flex-1 justify-center items-center flex-col">
					<h2 className="mb-2">{t("not-onboarded.title")}</h2>
					<p className="max-w-[500px] text-center">
						{t("not-onboarded.description")}
					</p>
					<Button className="mt-4" to="/dashboard">
						{t("not-onboarded.button")}
					</Button>
				</div>
			</Layout>
		);
	}

	return (
		<Layout
			breadcrumb={[
				{
					to: "/offers",
					label: t("title"),

					isHome: true,
				},
			]}
			title={t("title")}
		>
			<Layout.Header title={t("title")}>
				{auth.type === "student" && (
					<div className="flex items-center gap-6">
						{!isTablet && (
							<OfferAvailableWorkSwitch
								defaultValue={auth.status.is_available}
								type="all"
							/>
						)}
						<Button
							small={isPhone}
							type="primary"
							to="/offers/create"
						>
							<i
								className={`fas fa-plus ${
									!isPhone ? "mr-2" : "mr-1"
								}`}
							></i>
							{t("create")}
						</Button>
					</div>
				)}
			</Layout.Header>
			{isTablet && (
				<div className="">
					<OfferAvailableWorkSwitch
						defaultValue={auth.status.is_available}
						type="all"
					/>
				</div>
			)}
			<div>
				<FilterTabs
					tabs={sorts}
					variant={auth.type === "student" ? "dark" : "light"}
					active={sort}
					onChange={setSort}
				/>
			</div>
			<OfferList
				query={`with[]=statistics&with[]=unread_messages&sort=${sort}`}
			/>
		</Layout>
	);
}
